import { IBrandSourceProps } from "./IBrandSourceProps";

export function BrandCracked({ svgStyle, outlineStyle, filledStyle }: IBrandSourceProps) {
    return (
        <svg viewBox="0 0 340 371" style={svgStyle}>
            <g transform="matrix(1,0,0,1,-16906,-3626)">
                <g transform="matrix(3.5417,0,0,1.4857,22390.6,28.9254)">
                    <g transform="matrix(0.244246,0,0,0.37622,-1587.51,915.159)">
                        <path
                            d="M356.347,4268.43L404.507,4367.9L379.936,4450.98L407.859,4515.76L407.859,4450.14L441.61,4355.84L415.748,4252.34C395.601,4261.85 382.784,4264.72 356.347,4268.43Z"
                            style={outlineStyle}
                        />
                    </g>
                    <g transform="matrix(0.28235,0,0,0.673082,-6322,-19.4692)">
                        <path
                            d="M17133.6,3723.76C17147.1,3729.16 17155.2,3735.95 17155.2,3743.33C17155.2,3760.9 17109.6,3775.16 17053.4,3775.16C16997.3,3775.16 16951.7,3760.9 16951.7,3743.33C16951.7,3735.95 16959.7,3729.15 16973.2,3723.75L16973.2,3689.33C16968.3,3690.97 16963.8,3692.79 16960.1,3694.81C16936.8,3707.53 16912.8,3726.32 16912.8,3765.13L16932.8,3920.02C16932.8,3958.83 16964.3,3990.33 17003.1,3990.33L17103.7,3990.33C17133.2,3990.33 17158.4,3972.23 17168.9,3946.57L17203.7,3946.57C17216.7,3946.57 17227.2,3935.47 17227.2,3921.8L17239.2,3804.89C17239.2,3791.22 17225.7,3780.12 17212.7,3780.12L17192.1,3780.12L17194,3765.13C17194,3726.32 17174.3,3707.53 17150.7,3694.81C17146.1,3692.33 17140.3,3690.15 17133.6,3688.24L17133.6,3723.76ZM17188.7,3806.5L17174,3920.02L17174,3920.19L17185.6,3920.19C17195.4,3920.19 17200.3,3911.85 17200.3,3901.56L17209.3,3825.13C17209.3,3814.85 17204.4,3806.5 17194.6,3806.5L17188.7,3806.5ZM17076.4,3774.43L17118,3830.02L17096.8,3876.47L17120.9,3912.68L17120.9,3876L17150.1,3823.28L17127.8,3765.43C17110.3,3770.75 17099.2,3772.35 17076.4,3774.43Z"
                            style={filledStyle}
                        />
                    </g>
                    <g transform="matrix(1,0,0,1,316.464,1280.44)">
                        <g transform="matrix(0.28235,0,0,0.673082,-6322,-19.4692)">
                            <path
                                d="M16004.5,1735.08C16010.1,1735.2 16012.7,1740.15 16012.8,1742.7C16012.9,1760.22 16012.8,1840.97 16012.8,1840.97L15979.2,1840.94L15886.1,1840.94L15852.5,1840.97C15852.5,1840.97 15852.4,1760.22 15852.5,1742.7C15852.5,1740.12 15855.2,1735.07 15860.9,1735.08C15861.7,1735.08 15862.8,1735.08 15864.1,1735.08L15864.1,1735.03L16004.5,1735.03L16004.5,1735.08Z"
                                style={outlineStyle}
                            />
                        </g>
                        <g transform="matrix(0.28235,0,0,0.673082,-6322,-19.4692)">
                            <path d="M15979.2,1735.03L15979.2,1840.94" style={outlineStyle} />
                        </g>
                        <g transform="matrix(0.28235,0,0,0.673082,-6322,-19.4692)">
                            <path
                                d="M15886.1,1840.94C15886.1,1805.63 15886.1,1770.33 15886.1,1735.03C15886.1,1770.33 15886.1,1805.63 15886.1,1840.94Z"
                                style={outlineStyle}
                            />
                        </g>
                        <g transform="matrix(0.199147,-0.0363527,0.0215564,0.671074,-4895.89,-183.994)">
                            <path d="M15008.7,2824.81L15056.1,2827.39" style={outlineStyle} />
                        </g>
                        <g transform="matrix(0.199139,-0.0365966,0.021701,0.671048,-4896.18,-162.023)">
                            <path d="M15008.7,2824.81L15056.1,2827.39" style={outlineStyle} />
                        </g>
                        <g transform="matrix(0.199147,-0.0363527,0.0215564,0.671074,-4895.89,-147.533)">
                            <path d="M15008.7,2824.81L15056.1,2827.39" style={outlineStyle} />
                        </g>
                        <g transform="matrix(0.199147,-0.0363527,0.0215564,0.671074,-4860.11,-183.994)">
                            <path d="M15008.7,2824.81L15056.1,2827.39" style={outlineStyle} />
                        </g>
                        <g transform="matrix(0.199139,-0.0365966,0.021701,0.671048,-4860.4,-162.023)">
                            <path d="M15008.7,2824.81L15056.1,2827.39" style={outlineStyle} />
                        </g>
                        <g transform="matrix(0.199147,-0.0363527,0.0215564,0.671074,-4860.1,-147.533)">
                            <path d="M15008.7,2824.81L15056.1,2827.39" style={outlineStyle} />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
